import React from "react";
import { Dialog, Button, DialogActions } from "@material-ui/core";
import CommonButton from "./Component/Button/CommonButton";

export default function GlobitsConfirmationDialog(props) {
  const {
    open,
    onConfirmDialogClose,
    text,
    title,
    agree,
    cancel,
    onYesClick,
    textConfirmButtonSecond = null,
    onConfirmButtonSecond,
    maxWidth = "xs",
  } = props;
  return (
    <Dialog
      maxWidth={maxWidth}
      fullWidth={true}
      open={open}
      onClose={onConfirmDialogClose}
    >
      <div className="p-3">
        <h3 className="capitalize" style={{ color: "#4276a4" }}>
          {title}
        </h3>
        <p className="mt-3 mb-5">{text}</p>
        <DialogActions>
          <div className="flex flex-end">
            <Button
              variant="contained"
              className="mr-2 btn-danger"
              onClick={onConfirmDialogClose}
            >
              {cancel}
            </Button>
            {textConfirmButtonSecond && (
              <Button
                onClick={onConfirmButtonSecond}
                className="btn-primary btn-primary-md mr-2"
              >
                {textConfirmButtonSecond}
              </Button>
            )}
            {agree && (
              <Button
                className="btn-orange"
                variant="contained"
                onClick={onYesClick}
              >
                {agree}
              </Button>
            )}
          </div>
        </DialogActions>
      </div>
    </Dialog>
  );
}
